/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useRef } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useHistory, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_LOGOUT, API_SERVER, API_SCT, API_GET_PUBLIC } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import Tour from 'reactour'
import LinesEllipsis from 'react-lines-ellipsis'
import TextareaAutosize from 'react-textarea-autosize';
import ReactPlayer from 'react-player/lazy'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Loading]
-------------------------------------------------------------------*/
import ReactLoading from 'react-loading';
/*------------------------------------------------------------------
[End Loading]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Route JSON]
-------------------------------------------------------------------*/
import { route, route_name } from "./@api.json";
/*------------------------------------------------------------------
[End Route JSON]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev, convertDateDBtoIndo } from '../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import OverlayBg from '../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = route_name;
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = route;
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [loading_stuck, set_loading_stuck] = useState(false);
    const [tour, set_tour] = useState(false);
    const [tab, set_tab] = useState(null);

    const [refresh, set_refresh] = useState(null);
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [table_height, set_table_height] = useState(0);

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [data_story, set_data_story] = useState(null);
    const [data_entry, set_data_entry] = useState(null);
    const [data_entry_populer, set_data_entry_populer] = useState(null);

    const [search, set_search] = useState('');
    const [search_public, set_search_public] = useState('');
    const [data_user_online, set_data_user_online] = useState(null);
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')
    const [name, set_name] = useState('')
    const [title, set_title] = useState('')
    const [entry, set_entry] = useState('')
    const [url, set_url] = useState('')
    const [type, set_type] = useState('')
    const [data_notification, set_data_notification] = useState(null);
    const [notification_count, set_notification_count] = useState(0);
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Ref]
    ----------------------------------------------------------------*/
    const ref_table_height = useRef(null)
    /*--------------------------------------------------------------
    [End Ref]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___step_1',
          content: 'Content 1',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket_online = () => {

        socket.on(`${route}_user_authentication`, (data) => {
			// console.log(`${route}_user_authentication : `, data)
            set_data_user_online(data)	
		})

        socket.emit(`${route}_user_authentication`, {
            action: 'connect_public',
            room: `room_${route}_user_authentication`,
            status: 'online_public',
            bamboo_user : random_character(16),
            username : random_character(16),
            name : random_character(16),
            e_account : `e_${route}`,
        });
		
	}
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== undefined){

            let storage_bamboo = STORAGE_USER[0].bamboo;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                _socket_online(STORAGE_USER[0])
            }

        }else{
            _socket_online()
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    // if(STORAGE_USER !== undefined){
    //     if(STORAGE_USER[0].level === 'guest'){
    //         history.push('/')
    //     }
    // }else{
    //     history.push('/home')
    //     window.location.reload();
    // }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search_public.length > 0){
            _search_public()
        }else{
            _STORAGE_USER()
        }

    }, [refresh, search_public])

    useEffect(() => {

        if(ref_table_height.current){
            set_table_height(ref_table_height.current.clientHeight + 5)
        }

    }, [data])

    useEffect(() => {
        
        setTimeout(() => {
                
            set_loading_stuck(true) 
            
        }, 2500);

    }, [])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            {

                !loading_stuck &&
                <div className="_app_loading">
                    <div className="_position_middle">
                        <ReactLoading type={'cylon'} color={'#222'} height={50} width={50} />
                    </div>				
                </div>	
            
            }
            
            <div style={{fontFamily: 'Inter-Medium', backgroundColor: '#161616'}}>

                <div style={{position: 'absolute', top: 0, right: 0, left: 0, backgroundColor: '#161616', height: 70}}>
                    <div className="_container _relative">
                        <div style={{position: 'absolute', top: 20, left: 20}}>
                            <h2 style={{fontFamily: 'Inter-Regular', marginBottom: 6, color: '#fff'}}>Mega Merah</h2>
                        </div>

                        <div style={{position: 'absolute', top: 20, right: 20}}>
                            <div className="_row _center_align">
                                <NavLink 
                                    to={`/${route}/login`}
                                    style={{marginRight: 16, color: '#fff'}}
                                >
                                    Masuk
                                </NavLink>
                                <NavLink 
                                    to={`/${route}/register`}
                                    style={{backgroundColor: 'lightseagreen', color: '#fff', paddingTop: 6, paddingBottom: 6, paddingLeft: 18, paddingRight: 18, borderRadius: 5}}
                                >
                                    Daftar
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{position: 'fixed', bottom: 0, right: 0, left: 0, paddingBottom: 14, paddingTop: 16, backgroundColor: '#161616', zIndex: 100, borderTopWidth: 1, borderTopColor: 'rgba(255,255,255,0.1)', borderTopStyle: 'solid'}}>
                    <div className="_container _relative">
                        <div className="_lily_pad_h_d">
                            <div className="_row">
                                <div className="_column">
                                    <p className="_font_size_10px" style={{color: '#aaa'}}>Live Streaming</p>
                                    <div style={{display: 'inline-block'}}>
                                        <marquee>
                                            <LinesEllipsis
                                                style={{color: '#fff'}}
                                                text={'Murottal Alquran'}
                                                maxLine='1'
                                                ellipsis='...'
                                                trimRight
                                                basedOn='letters'
                                            />
                                        </marquee>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{height: 100}}/>

                <div className="_container">
                    <div className="_lily_pad_h_d">
                        <h1 style={{fontFamily: 'Inter-Regular', marginBottom: 6, color: '#fff'}}>Live Streaming</h1>
                        <p style={{color: '#bbb'}}>Live Audio Ceramah, Murottal</p>
                        <div className="_row_sync_2" style={{marginLeft: -10, marginRight: -10}}>
                            <div className="_column_sync_2">
                                <div style={{position: 'relative', height: 200, overflow: 'hidden', backgroundColor: '#264653', borderRadius: 8}}>
                                    <div style={{position: 'absolute', left: 20, top: 20}}>
                                        <p className="_font_size_30px" style={{color: '#fff'}}>Alqur'an</p>
                                        <p className="_btn _push_t_t" style={{color: '#fff', borderColor: 'rgba(255,255,255,0.4)'}}>Live Sekarang</p>
                                    </div>
                                    <div style={{bottom: -50, right: -20, position: 'absolute', width: 200, height: 200, borderRadius: 100, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                    <div style={{bottom: -20, right: 30, position: 'absolute', width: 180, height: 180, borderRadius: 100, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                    <div style={{bottom: -20, right: 70, position: 'absolute', width: 150, height: 150, borderRadius: 80, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                    <div style={{bottom: -20, right: 90, position: 'absolute', width: 80, height: 80, borderRadius: 80, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                </div>
                            </div>
                            <div className="_column_sync_2">
                                <div style={{position: 'relative', height: 200, overflow: 'hidden', backgroundColor: '#2a9d8f', borderRadius: 8}}>
                                    <div style={{position: 'absolute', left: 20, top: 20}}>
                                        <p className="_font_size_30px" style={{color: '#fff'}}>Ceramah</p>
                                        <p className="_btn _push_t_t" style={{color: '#fff', borderColor: 'rgba(255,255,255,0.4)'}}>Live Sekarang</p>
                                    </div>
                                    <div style={{bottom: -50, right: -20, position: 'absolute', width: 200, height: 200, borderRadius: 100, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                    <div style={{bottom: -20, right: 30, position: 'absolute', width: 180, height: 180, borderRadius: 100, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                    <div style={{bottom: -20, right: 70, position: 'absolute', width: 150, height: 150, borderRadius: 80, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                    <div style={{bottom: -20, right: 90, position: 'absolute', width: 80, height: 80, borderRadius: 80, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                </div>
                            </div>
                            <div className="_column_sync_2">
                                <div style={{position: 'relative', height: 200, overflow: 'hidden', backgroundColor: '#f4a261', borderRadius: 8}}>
                                    <div style={{position: 'absolute', left: 20, top: 20}}>
                                        <p className="_font_size_30px" style={{color: '#fff'}}>Sholawat</p>
                                        <p className="_btn _push_t_t" style={{color: '#fff', borderColor: 'rgba(255,255,255,0.4)'}}>Live Sekarang</p>
                                    </div>
                                    <div style={{bottom: -50, right: -20, position: 'absolute', width: 200, height: 200, borderRadius: 100, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                    <div style={{bottom: -20, right: 30, position: 'absolute', width: 180, height: 180, borderRadius: 100, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                    <div style={{bottom: -20, right: 70, position: 'absolute', width: 150, height: 150, borderRadius: 80, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                    <div style={{bottom: -20, right: 90, position: 'absolute', width: 80, height: 80, borderRadius: 80, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                </div>
                            </div>
                            <div className="_column_sync_2">
                                <div style={{position: 'relative', height: 200, overflow: 'hidden', backgroundColor: '#e76f51', borderRadius: 8}}>
                                    <div style={{position: 'absolute', left: 20, top: 20}}>
                                        <p className="_font_size_30px" style={{color: '#fff'}}>Dzikir</p>
                                        <p className="_btn _push_t_t" style={{color: '#fff', borderColor: 'rgba(255,255,255,0.4)'}}>Live Sekarang</p>
                                    </div>
                                    <div style={{bottom: -50, right: -20, position: 'absolute', width: 200, height: 200, borderRadius: 100, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                    <div style={{bottom: -20, right: 30, position: 'absolute', width: 180, height: 180, borderRadius: 100, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                    <div style={{bottom: -20, right: 70, position: 'absolute', width: 150, height: 150, borderRadius: 80, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                    <div style={{bottom: -20, right: 90, position: 'absolute', width: 80, height: 80, borderRadius: 80, borderColor: 'rgba(255,255,255,0.5)', borderWidth: 1, borderStyle: 'solid', zIndex: 10}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="_lily_pad_h_d" style={{marginTop: 30}}>
                        <h1 style={{fontFamily: 'Inter-Regular', marginBottom: 6}}>Konsultasi Syariah</h1>
                        <p>Tersedia di pesan, audio, video dan live streaming</p>
                    </div>
                    <div className="_lily_pad_h_d" style={{marginTop: 30}}>
                        <h1 style={{fontFamily: 'Inter-Regular', marginBottom: 6}}>Rukiyah Syariah</h1>
                        <p>Dibantu oleh ustadz, dan ustadzah</p>
                    </div>

                    <div className="_lily_pad_h_d" style={{marginTop: 30}}>
                        <h1 style={{fontFamily: 'Inter-Regular', marginBottom: 6}}>Podcast</h1>
                        <p>Live Streaming Audio dan Video</p>
                    </div>
                    <div className="_lily_pad_h_d" style={{marginTop: 30}}>
                        <h1 style={{fontFamily: 'Inter-Regular', marginBottom: 6}}>Belajar</h1>
                        <p>Tersedia di pesan, audio, video dan live streaming</p>
                    </div>
                    <div className="_lily_pad_h_d" style={{marginTop: 30}}>
                        <h1 style={{fontFamily: 'Inter-Regular', marginBottom: 6}}>AlQ'uran & Hadist</h1>
                        <p>Alquran dan hadist Online</p>
                    </div>
                    <div className="_lily_pad_h_d" style={{marginTop: 30}}>
                        <h1 style={{fontFamily: 'Inter-Regular', marginBottom: 6}}>Toko</h1>
                        <p>Berjualan halal di tokomu</p>
                    </div>
                    <div className="_lily_pad_h_d" style={{marginTop: 30}}>
                        <h1 style={{fontFamily: 'Inter-Regular', marginBottom: 6}}>Event</h1>
                        <p>Hadir untuk menjalankan kegiatan dengan nuansa islam</p>
                    </div>
                    <div className="_lily_pad_h_d" style={{marginTop: 30}}>
                        <h1 style={{fontFamily: 'Inter-Regular', marginBottom: 6}}>Profile</h1>
                        <p>Semua Profile guru kita</p>
                    </div>
                    <div className="_lily_pad_h_d" style={{marginTop: 30}}>
                        <h1 style={{fontFamily: 'Inter-Regular', marginBottom: 6}}>Lokasi Pengajian</h1>
                        <p>Daftar lokasi pengajian yang dapat anda hadiri</p>
                    </div> */}
                    <div className="_lily_pad_h_d" style={{marginTop: 30}}>
                        <h1 style={{color: '#fff', fontFamily: 'Inter-Regular', marginBottom: 6}}>Donasi</h1>
                        <p style={{color: '#bbb'}}>Digunakan untuk perusahaan supaya tetap semangat menjalankan dakwah dan </p>
                        <p style={{color: '#bbb'}}>untuk masyarakat yang membutuhkan</p>
                        <p style={{color: '#bbb'}}>Hubungi ke <span style={{color: '#fff'}}>flamecorecloud@gmail.com</span></p>
                    </div>
                    <div className="_lily_pad_h_d" style={{marginTop: 30}}>
                        <h1 style={{color: '#fff', fontFamily: 'Inter-Regular', marginBottom: 6}}>Partner</h1>
                        <p style={{color: '#bbb'}}>Flamecore Cloud, Digitali, Trip Juara, Plano Studio</p>
                    </div>
                    <div style={{height: 120}}></div>
                </div>

            </div>

        </>
    );

}

export default Screen;